import * as React from 'react'
import * as ReactDOM from 'react-dom/client'
import { BrowserRouter as Router } from 'react-router-dom'

import { FlashMessage } from '@ulule/owl-kit-components'

import { Header } from '@ulule/header'
import { t } from '@ulule/localize'
import { TrackingProvider } from '@owl-nest/shadow'
import * as layout from '@owl-nest/layout'

const FlashMessages = (props) => {
  const [messages, setMessages] = React.useState(props.messages)

  return (
    <div>
      {messages.map((message, index) => (
        <FlashMessage
          key={index}
          level={message.tags}
          onClickClose={() => {
            setMessages(messages.filter((_, current) => index !== current))
          }}
          closable
          translations={{
            close: t('Close'),
          }}
        >
          <div dangerouslySetInnerHTML={{ __html: message.children }}></div>
        </FlashMessage>
      ))}
    </div>
  )
}

export const renderCommonComponents = () => {
  // Render header
  const headerContainer = document.getElementById('react-ulule-header')

  if (headerContainer) {
    const root = ReactDOM.createRoot(headerContainer)
    root.render(
      <TrackingProvider
        getUserId={() => (window.UFE.user && window.UFE.user.id) || undefined}
        gtmContainerId={window.UFE.gtmKey}
      >
        {/* This is needed as it is a dependency for partnership tracking. Not ideal. */}
        <Router>
          <Header enableSubnav={shouldDisplaySubnav()} />
        </Router>
      </TrackingProvider>,
    )
  }

  // render footer
  const footerContainer = document.getElementById('react-ulule-footer')

  if (footerContainer) {
    const root = ReactDOM.createRoot(footerContainer)
    root.render(<layout.Footer lang={window.UFE.locale} navSections={layout.getNavSectionList(window.UFE.locale)} />)
  }

  const flashContainer = document.getElementById('react-flash-message')
  const messages = window.UFE.notifications

  if (flashContainer && messages) {
    const root = ReactDOM.createRoot(flashContainer)
    root.render(<FlashMessages messages={messages} />)
  }

  const highlightsContainer = document.getElementById('react-highlights')
  const highlights = window.UFE.highlights

  if (highlightsContainer && highlights) {
    const root = ReactDOM.createRoot(highlightsContainer)
    root.render(<FlashMessages messages={highlights} />)
  }
}

function shouldDisplaySubnav() {
  return (
    document.location.pathname.startsWith('/categories') ||
    document.location.pathname.startsWith('/channels') ||
    document.location.pathname.startsWith('/discover')
  )
}
